export var getIsDisabledState = (disabledState, widgetInternalDisabledState) => {
  return disabledState || widgetInternalDisabledState;
};